import { createStore } from 'vuex'
//import MobileRefData from "@/services/MobileRefData"

const store = createStore({
	state() {
		return {
			pageTitle: 'Fahrzeugmarkt',
			lastFilter: '',
			search: '',
			filterItems: {},
			sortItems: {
				adProperty: 'images',
				sortOrder: -1,
			},
			pageNum: 1,
			delivery: '',
			countActiveFilters: 0,
			storeId: false,
			price: {
				filter: 'fixed',
				view: 'finance',
				rate: [0, 600],
				financing: {
					period: 60,
					deposit: 0,
					rate: 0,
				},
				leasing: {
					period: 48,
					deposit: 0,
					mileage: 10000,
					rate: 0,
				},
			},
			user: {
				token: '',
				tradeIn: '',
				bookmarks: {
					cars: {},
					search: {},
				},
			},
		}
	},
	mutations: {
		setPage(state, pageNum) {
			state.pageNum = parseInt(pageNum)
		},
		setFormToken(state, token) {
			state.user.token = token
		},
		updateSort(state, sortItem) {
			state.sortItems.adProperty = sortItem[0]
			state.sortItems.sortOrder = parseInt(sortItem[1])
			state.pageNum = 1
		},
		updateFilter(state, filterItem) {
			state.pageNum = 1
			state.lastFilter = filterItem.adPropertyKey
			state.filterItems[filterItem.adPropertyKey] = {
				adPropertyKey: filterItem.adPropertyKey,
				adPropertyValue: filterItem.adPropertyValue,
				adPropertyType: filterItem.adPropertyType,
			}
			if (filterItem.adPropertyKey === 'make') {
				if (state.filterItems['model']) {
					delete state.filterItems['model']
				}
			}
			if (state.filterItems['usageType']) {
				delete state.filterItems['condition']
			}
			state.countActiveFilters = Object.keys(state.filterItems).length
		},
		updatePrice(state, price) {
			state.pageNum = 1
			if (price === 'leasing') {
				delete state.filterItems['range-from-financing-monthlyInstallment']
				delete state.filterItems['range-till-financing-monthlyInstallment']
			} else if (price === 'finance') {
				delete state.filterItems[
					'range-from-darmasDeLeasing-rates-grossRateNum'
				]
				delete state.filterItems[
					'range-till-darmasDeLeasing-rates-grossRateNum'
				]
			} else {
				delete state.filterItems['range-from-financing-monthlyInstallment']
				delete state.filterItems['range-till-financing-monthlyInstallment']
				delete state.filterItems[
					'range-from-darmasDeLeasing-rates-grossRateNum'
				]
				delete state.filterItems[
					'range-till-darmasDeLeasing-rates-grossRateNum'
				]
			}
			state.price.filter = price

			console.log(state)
		},
		deletePrice(state) {
			state.pageNum = 1
			state.price.filter = 'fixed'
			delete state.filterItems['range-from-financing-monthlyInstallment']
			delete state.filterItems['range-till-financing-monthlyInstallment']
			delete state.filterItems['range-from-darmasDeLeasing-rates-grossRateNum']
			delete state.filterItems['range-till-darmasDeLeasing-rates-grossRateNum']
		},
		setFilterFromUrl(state, urlFilters = null) {
			if (urlFilters.filterItems) {
				state.filterItems = urlFilters.filterItems
				// SET PRICE
				if (urlFilters.filterItems['range-from-financing-monthlyInstallment']) {
					state.price.rate[0] =
						+urlFilters.filterItems['range-from-financing-monthlyInstallment']
							.adPropertyValue
				}
				if (
					urlFilters.filterItems[
						'range-from-darmasDeLeasing-rates-grossRateNum'
					]
				) {
					state.price.rate[0] =
						+urlFilters.filterItems[
							'range-from-darmasDeLeasing-rates-grossRateNum'
						].adPropertyValue
				}
				if (urlFilters.filterItems['range-till-financing-monthlyInstallment']) {
					state.price.rate[1] =
						+urlFilters.filterItems['range-till-financing-monthlyInstallment']
							.adPropertyValue
				}
				if (
					urlFilters.filterItems[
						'range-till-darmasDeLeasing-rates-grossRateNum'
					]
				) {
					state.price.rate[1] =
						+urlFilters.filterItems[
							'range-till-darmasDeLeasing-rates-grossRateNum'
						].adPropertyValue
				}
				state.countActiveFilters = Object.keys(state.filterItems).length
			}
			if (urlFilters.search) {
				state.search = urlFilters.search
				state.countActiveFilters++
			}
			if (urlFilters.price) {
				state.price.filter = urlFilters.price
				state.countActiveFilters++
			}
			if (urlFilters.delivery) {
				state.delivery = 'now'
				state.countActiveFilters++
			}
			if (urlFilters.pageNum) {
				state.pageNum = urlFilters.pageNum
			}
			if (urlFilters.sortItems) {
				state.sortItems = urlFilters.sortItems
			}
		},
		deleteFilter(state, filterkey) {
			state.pageNum = 1
			if (state.filterItems[filterkey]) {
				delete state.filterItems[filterkey]
				if (
					filterkey === 'range-from-financing-monthlyInstallment' ||
					filterkey === 'range-from-darmasDeLeasing-rates-grossRateNum'
				) {
					state.price.rate[0] = 0
				}
				if (
					filterkey === 'range-till-financing-monthlyInstallment' ||
					filterkey === 'range-till-darmasDeLeasing-rates-grossRateNum'
				) {
					state.price.rate[1] = 600
				}
			}
			if (filterkey === state.lastFilter) {
				state.lastFilter = ''
			}
			if (filterkey === 'make') {
				delete state.filterItems['model']
			}

			state.countActiveFilters =
				state.countActiveFilters > 0 ? state.countActiveFilters - 1 : 0
		},
		deleteAllFilter(state) {
			state.filterItems = {}
			state.countActiveFilters = 0
			state.lastFilter = ''
			state.search = ''
			state.price.filter = 'fixed'
			state.pageNum = 1
		},
		updateSearch(state, searchItem) {
			state.pageNum = 1
			state.search = searchItem
			if (searchItem !== '') {
				state.countActiveFilters = state.countActiveFilters + 1
			} else {
				state.countActiveFilters = state.countActiveFilters - 1
			}
		},
		addCarToBookmarks(state, car) {
			const creationDate = new Date()
			state.user.bookmarks.cars[car._id] = {
				id: car._id,
				creationDate: creationDate,
				internalNumber: car.ad.internalNumber,
				useageType: car.ad.usageType,
				condition: car.ad.condition,
				title: car.ad.make + ' ' + car.ad.modelDescription,
				price: car.ad.price.consumerPriceGross,
			}
			window.localStorage.setItem(
				'bookmarkedCars',
				JSON.stringify(state.user.bookmarks.cars)
			)
		},
		addTradeIn(state, car) {
			const creationDate = new Date()
			const tradeIn = {
				id: car._id,
				creationDate: creationDate,
				internalNumber: car.ad.internalNumber,
			}
			state.user.tradeIn = tradeIn
			window.localStorage.setItem('tradeIn', JSON.stringify(tradeIn))
		},
		removeTradeIn(state) {
			state.user.tradeIn = ''
			window.localStorage.removeItem('tradeIn')
		},
		loadTradeInFromLocalStorage(state, tradeInStorage) {
			const tradeIn = JSON.parse(tradeInStorage)
			state.user.tradeIn = {
				id: tradeIn.id,
				creationDate: tradeIn.creationDate,
				internalNumber: tradeIn.internalNumber,
			}
		},
		removeCarFromBookmarks(state, carId) {
			delete state.user.bookmarks.cars[carId]
			if (Object.keys(state.user.bookmarks.cars).length > 0) {
				window.localStorage.setItem(
					'bookmarkedCars',
					JSON.stringify(state.user.bookmarks.cars)
				)
			} else {
				window.localStorage.removeItem('bookmarkedCars')
			}
		},
		loadBookmarksFromLocalStoreage(
			state,
			bookmarkedCars = null,
			bookmarkedSearch = null
		) {
			if (bookmarkedCars) {
				state.user.bookmarks.cars = JSON.parse(bookmarkedCars)
			}
			if (bookmarkedSearch) {
				state.user.bookmarks.search = JSON.parse(bookmarkedSearch)
			}
		},
		addSearchToBookmarks(state, searchUrl, title) {
			const creationDate = new Date()
			state.user.bookmarks.search = {
				creationDate: creationDate,
				title: title,
				url: searchUrl,
			}
			window.localStorage.setItem(
				'bookmarkedSearch',
				JSON.stringify(state.user.bookmarks.search)
			)
		},
		setStore(state, storeId = false) {
			if (storeId === false) {
				state.countActiveFilters = state.countActiveFilters - 1
				state.storeId = false
			} else {
				state.countActiveFilters = state.countActiveFilters + 1
				state.storeId = storeId
			}
		},
	},
})

export default store
